import React, { useState } from "react";
import { useSelector } from "react-redux";
import useGetJsonByApplicationNLang from "../lms-shared/hooks/useGetJsonByApplicationNLang";
import Collapse from "../UI/Collapse/Collapse";
import closeIcon from '../../assests/header/close.png';
import classes from "./FAQ.module.css";
import { onKeyDown } from "../../service";

const FAQ = ({ setShowFAQ }) => {

    const { texts, direction } = useSelector(state => state.translate);
    const [FAQ, setFAQ] = useState()
    useGetJsonByApplicationNLang('faq', res => res && setFAQ(res.faq))

    return (
        <div className={`${classes[direction]} ${classes.FAQContainer}`}>
            <div className={classes.FAQ}>
                <div className={classes.Header}>
                    <h2>{texts.FAQ}</h2>
                    <img src={closeIcon} alt="close" onClick={() => setShowFAQ(false)} tabIndex="0" role="button" onKeyDown={e => onKeyDown(e, () => setShowFAQ(false))}/>
                </div>
                <div className={classes.AllQuestionAndAnswer}>
                    {FAQ && FAQ.map((f, index) => <div key={index}>
                        <h3 className={classes.TitleContent}>{f.title}</h3>
                        {f.content && f.content.map((c, index) => <Collapse key={index} title={c.question} content={c.answer}></Collapse>)}
                    </div>
                    )}
                </div>
            </div>
        </div>
    )
}
export default FAQ